import {
  Box,
  Pagination as DefaultPagination,
  MenuItem,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { PaginationBlock, PaginationStyled } from "./styled";
import { PaginationItem } from "@mui/material";
import ArrowLeft from "@/assets/icons/arrow-left2.svg?react";
import ArrowDown from "@/assets/icons/downArrowPagination.svg?react";
// import { useAppSelector } from 'redux-store/hooks';
// import { getDesignTokens } from 'configs/theme';
import { useTranslation } from "react-i18next";
import { hexToRgba } from "@/Components/helpers/util";

type Props = {
  id?: string;
  total: number;
  paginationModel: { page: number; pageSize: number };
  setPaginationModel: (pagination: { pageSize: number; page: number }) => void;
  itemCount?: number;
};

export default function Pagination(props: Props) {
  const { t } = useTranslation(["common", "apiGovernance"]);

  const {
    id = "snr-ai-pagination",
    total,
    paginationModel,
    setPaginationModel,
    itemCount,
  } = props;
  // const { theme, otherTheme } = useAppSelector((state) => state.app);
  // const designToken = getDesignTokens(theme, otherTheme);
  const theme = useTheme();
  const page = paginationModel?.page || 1;
  const size = paginationModel?.pageSize;

  const rowsPageList = [
    { label: 10, val: 10 },
    { label: 15, val: 15 },
    { label: 20, val: 20 },
    { label: 25, val: 25 },
  ];

  return (
    <PaginationBlock gap={5}>
      {/* {total > 0 && (
				<Typography fontSize={'13px'} fontWeight={400} lineHeight={'24px'}>
					{t('Showing')} {itemCount || size} {t('out of')} {total ?? 0} {t('Records')}
				</Typography>
			)} */}
      {total > 0 && (
        <Typography fontSize={"13px"} fontWeight={400} lineHeight={"24px"}>
          {total <= 10
            ? `${t("Showing")} ${total} ${t("out of")} ${total} ${t("Records")}`
            : `${t("Showing")} ${itemCount || size} ${t("out of")} ${total} ${t(
                "Records"
              )}`}
        </Typography>
      )}
      {total > 10 && (
        <>
          <Stack direction="row" alignItems="center" gap={2}>
            {/* Rows per page: */}
            <TextField
              id={`${id}-rows-per-page`}
              size="small"
              defaultValue={size}
              select
              onChange={(value) => {
                if (setPaginationModel) {
                  setPaginationModel({
                    pageSize: Number(value.target.value),
                    page: 1,
                  });
                }
              }}
              sx={{
                "& input:valid:focus + fieldset": {
                  borderColor: theme?.palette?.primary.main,
                },
                "& label.Mui-focused": {
                  color: theme?.palette?.primary.main,
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: theme?.palette?.primary.main,
                },
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: theme?.palette?.primary.main,
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: theme?.palette?.primary.main,
                  },
                },
              }}
              SelectProps={{
                style: { fontSize: 13 },
                IconComponent: (prop) => (
                  <ArrowDown id={`${id}-rows-per-page-icon`} {...prop} />
                ),
              }}
            >
              {rowsPageList.map((option) => (
                <MenuItem
                  id={`${id}-rows-per-page-item-${option.val}`}
                  key={option.val}
                  value={option.val}
                  sx={{
                    fontSize: "13px",
                    "&:hover": {
                      background: hexToRgba(theme?.palette?.primary.main, 0.07),
                    },
                  }}
                >
                  {option.label} {t("per page")}
                </MenuItem>
              ))}
            </TextField>
          </Stack>

          <Stack direction="row" alignItems="center" gap={2}>
            <PaginationStyled>
              <DefaultPagination
                id={`${id}-pagination`}
                shape="rounded"
                count={Math.ceil(total / size) || 1}
                variant="outlined"
                defaultPage={Number(page || 1)}
                onChange={(_, pageNumber) => {
                  setPaginationModel({
                    pageSize: paginationModel?.pageSize,
                    page: pageNumber,
                  });
                }}
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    slots={{
                      previous: () => (
                        <Box display={"flex"} alignItems={"center"} gap={1}>
                          <ArrowLeft id={`${id}-pagination-icon`} />
                          <Typography
                            fontFamily={"Inter"}
                            fontSize={"13px"}
                            fontWeight={400}
                            lineHeight={"24px"}
                          >
                            {t("Prev")}
                          </Typography>
                        </Box>
                      ),
                      next: () => (
                        <Box display={"flex"} alignItems={"center"} gap={1}>
                          <Typography
                            fontFamily={"Inter"}
                            fontSize={"13px"}
                            fontWeight={400}
                            lineHeight={"24px"}
                          >
                            {t("Next")}
                          </Typography>
                          <ArrowLeft
                            id={`${id}-pagination-icon`}
                            style={{
                              transform: "rotate(180deg)",
                            }}
                          />
                        </Box>
                      ),
                    }}
                    sx={{
                      "&:hover": {
                        background: `${hexToRgba(
                          theme?.palette?.primary.main,
                          0.07
                        )} !important`,
                      },
                      "&.Mui-selected": {
                        color: "#fff",
                        border: "none",
                        background: theme?.palette?.primary.main,
                        "&:hover": {
                          background: `${hexToRgba(
                            theme?.palette?.primary.main,
                            0.07
                          )} !important`,
                        },
                      },
                    }}
                  />
                )}
              />
            </PaginationStyled>
          </Stack>
        </>
      )}
    </PaginationBlock>
  );
}
